import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { USERAPI, cacheUserInfo } from '../../../../../services/api';
import { cookie } from '@ifeng-fe/ui_base';

// const linksUrl = {
//     linkwx:
//         'https://open.weixin.qq.com/connect/qrconnect?appid=wx10ce490118943a33&redirect_uri=http%3A%2F%2Fid.ifeng.com%2Fcallback%2Fweixin&response_type=code&scope=snsapi_login&state=',
//     linksina:
//         'https://api.weibo.com/oauth2/authorize?client_id=1073104718&redirect_uri=http%3A%2F%2Fid.ifeng.com%2Fcallback%2Fsina&response_type=code',
//     linkqq:
//         'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100514926&redirect_uri=https://id.ifeng.com/callback/qzone&state=8bc42edbdbd6e37dedd1cee53f009b7f&scope=get_user_info,add_share,list_album,add_album,upload_pic,add_topic,add_one_blog,add_weibo,check_page_fans,add_t,add_pic_t,del_t,get_repost_list,get_info,get_other_info,get_fanslist,get_idolist,add_idol,del_idol,get_tenpay_addr',
// };

const linksUrl = `${USERAPI}/api/v1/get/authorizeurl`;

class ThirdParty extends React.PureComponent {
    static propTypes = {};

    state = {};

    LOGINTIMER = null;

    handleClick = type => {
        console.log(type);

        const linkurl = `${linksUrl}?sns=${type}&platform=w&systemid=13`;

        window.open(linkurl, '', 'width=770, height=630');

        // clearInterval(this.LOGINTIMER);
        // this.LOGINTIMER = setInterval(() => {
        //     const sid = cookie.get('sid');

        //     if (sid) {
        //         console.log(sid);

        //         clearInterval(this.LOGINTIMER);
        //         cacheUserInfo();
        //     }
        // }, 100);
    };

    render() {
        return (
            <div className={styles.thirdParty}>
                <p className={styles.title}>------- 您也可以通过以下方式一键登录 -------</p>
                <div className={styles.btnBox}>
                    <div className={styles.btnWrapper}>
                        <div className={styles.linkwx} onClick={this.handleClick.bind(this, 'weixin')} />
                    </div>
                    <div className={styles.btnWrapper}>
                        <div className={styles.linkqq} onClick={this.handleClick.bind(this, 'qzone')} />
                    </div>
                    <div className={styles.btnWrapper}>
                        <div className={styles.linkweibo} onClick={this.handleClick.bind(this, 'sina')} />
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ThirdParty);
